import React from "react";
import BaseInfoIcon from "../../icons/base-info.icon";
import styles from "./info-banner.module.scss";

const InfoBanner = () => {
  return (
    <div className={styles.alert} role="alert" aria-live="polite">
      <div className={styles.alertIconWrapper}>
        <BaseInfoIcon className={styles.alertIcon} fill="#008FD4" aria-hidden="true" />
      </div>

      <div className={styles.alertTextWrapper}>
        <p className={styles.alertText}>
          You need the Support role to edit MSP settings. Contact your Global
          Administrator to get access.
        </p>
      </div>
    </div>
  );
};

export default InfoBanner;
